"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function default_1(props) {
    const { clock } = props;
    const { s, m, h } = clock;
    if (typeof h === 'string' || typeof m === 'string' || typeof s === 'string') {
        return null;
    }
    return (react_1.default.createElement("div", { className: "glx-analog--clock__circle" },
        react_1.default.createElement("span", { className: "glx-analog--clock__twelve" }),
        react_1.default.createElement("span", { className: "glx-analog--clock__three" }),
        react_1.default.createElement("span", { className: "glx-analog--clock__six" }),
        react_1.default.createElement("span", { className: "glx-analog--clock__nine" }),
        react_1.default.createElement("div", { className: "glx-analog--clock__rounder" }),
        react_1.default.createElement("div", { className: "glx-analog--clock__hour", style: { transform: `rotateZ(${h * 30 + (m * 6) / 12}deg)` } }),
        react_1.default.createElement("div", { className: "glx-analog--clock__minutes", style: { transform: `rotateZ(${m * 6}deg)` } }),
        react_1.default.createElement("div", { className: "glx-analog--clock__seconds", style: { transform: `rotateZ(${s * 6}deg)` } })));
}
exports.default = default_1;
